import React from 'react';

var SettingsWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-settings' }, children);
};

export { SettingsWr };
